import styled from 'styled-components';

import { TONE_COLORS, ACQ, COLORS } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const DEFAULT_EYEBROW_COLOR = TONE_COLORS.poor;

/** Deal-type eyebrow (affiliate / influencer cards): the type name carries the
 *  tenant orange, distinct from the default amber overline. */
export const DEAL_EYEBROW_COLOR = ACQ.orange;

export const Root = styled(Text)<{ $color: string }>`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.$color};
`;

/** Two-tone (deal) layout — an orange type name + a muted terms detail (with an
 *  optional magenta fixed-cost tail), in one baseline-aligned row (Figma 5px gap). */
export const Row = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  font-size: 12px;
  line-height: normal;
`;

export const Name = styled(Text)<{ $color: string }>`
  font-weight: 700;
  color: ${(p) => p.$color};
`;

/** Inline wrapper so the muted detail and its magenta tail sit directly adjacent
 *  (the detail's own trailing space separates them — no extra flex gap). */
export const DetailGroup = styled.span`
  font-weight: 300;
`;

export const Detail = styled(Text)`
  color: ${COLORS.eyebrowDetail};
`;

export const Accent = styled(Text)`
  font-weight: 700;
  color: ${COLORS.eyebrowAccent};
`;
